import { frUsers } from '../../modules/FrontUsers/Locales/fr/frUsers';
import { frGondoles } from '../../modules/Gondoles/Locales/frGondoles';
import { frIndicators } from '../../modules/Indicators/Locales/fr/frIndicators';

import { frRoles } from '../../modules/Roles/Locales/fr/frRoles';
import { frShops } from '../../modules/Shops/Locales/fr/frShops';
import { frTags } from '../../modules/Tags/Locales/fr/frTags';
import { frActualites } from '../../modules/News/Locales/fr/frActualites';
import { frAreas } from './frAreas';
import { frAudiences } from './frAudiences';
import { frAudits } from '../../modules/Audits/Locales/fr/frAudits';
import { frBackofficeUsers } from './frBackofficeUsers';
import { frChallenges } from '../../modules/Challenges/Locales/fr/frChallenges';
import { frCollections } from '../../modules/Collections/Locales/fr/frCollections';
import { frCommonActions } from './frCommonActions';
import { frCommonInfos } from './frCommonInfos';
import { frCommonNotifications } from './frCommonNotifications';
import { frCommons } from './frCommons';
import { frCommunications } from '../../modules/Communications/Locales/fr/frCommunications';
import { frContacts } from '../../modules/Contacts/Locales/fr/frContacts';
import { frEditor } from './frEditor';
import { frEvents } from './frEvents';
import { frHeader } from './frHeader';
import { frLogin } from './frLogin';
import { frMagicLink } from './frMagicLink';
import { frNavbar } from './frNavbar';
import { frNotifications } from './frNotifications';
import { frOffers } from './frOffers';
import { frOperations } from './frOperations';
import { frOthers } from './frOthers';
import { frPackagedOrders } from './frPackagedOrders';
import { frQuizzes } from '../../modules/Quizzes/Locales/fr/frQuizzes';
import { frReminders } from './frReminders';
import { frSectors } from './frSectors';
import { frStats } from './frStats';
import { frSurveys } from '../../modules/Surveys/Locales/fr/frSurveys';
import { frTeams } from './frTeams';
import { frToasts } from './frToasts';
import { frTunableOffers } from './frTunableOffers';
import { frVideos } from './frVideos';
import { frPasswords } from '../../../libs/IdeLink.Web.Common/src/modules/Auth/Locales/fr/frPasswords';
import { frPinCodes } from '../../modules/PinCodes/Locales/fr/frPinCodes';
import { frEntities } from '../../modules/Entities/Locales/fr/frEntities';

export const frMessages = {
    //* COMMON MESSAGES
    ...frCommons,
    ...frCommonInfos,
    ...frCommonActions,
    ...frCommonNotifications,

    ...frMagicLink, // * Pourquoi on a magic link sur Midas

    //* AUTHENTICATION
    ...frPasswords,
    ...frLogin,
    ...frNavbar,
    ...frHeader,

    //* MODULES
    ...frPackagedOrders,
    ...frTunableOffers,
    ...frOffers,
    ...frOperations,
    ...frCommunications,
    ...frEvents,
    ...frReminders,
    ...frSurveys,
    ...frVideos,
    ...frActualites,
    ...frChallenges,
    ...frQuizzes,
    ...frCollections,
    ...frAudits,
    ...frContacts,

    ...frIndicators,
    ...frGondoles,

    //* ADMIN MODULES
    ...frBackofficeUsers,
    ...frTeams,
    ...frEntities,
    ...frAreas,
    ...frSectors,
    ...frShops,
    ...frUsers,
    ...frRoles,
    ...frStats,
    ...frTags,
    ...frPinCodes,

    //* OTHERS
    ...frOthers,
    ...frAudiences,
    ...frNotifications,
    ...frEditor,
    ...frToasts,
};
